import { z } from "zod";
import { TransactionType, type TransactionFormData, PaymentMode } from "@/types";

// Input and output are both TransactionFormData (no transforms), which is what
// react-hook-form's zodResolver needs to type the form's field values.
export const transactionFormSchema: z.ZodType<TransactionFormData, TransactionFormData> = z.object({
  id: z.number().optional(),
  date: z.string().min(1, "Date is required"),
  type: z.nativeEnum(TransactionType),
  amount: z.number().min(0, "Amount must be greater than or equal to 0"),
  description: z.string().optional(),
  payee: z.string().optional(),
  merchantName: z.string().optional(),
  notes: z.string().optional(),
  referenceNo: z.string().optional(),
  accountId: z.number().min(1, "Account is required"),
  categoryId: z.number().nullable().optional(),
  tagIds: z.array(z.number()).optional(),
  isReviewed: z.boolean().optional(),
  isIncome: z.boolean().optional(),
  excludeFromBudget: z.boolean().optional(),
  paymentMode: z.nativeEnum(PaymentMode).optional(),
  currencyCode: z.string().optional(),
  tempDescription: z.string().optional(),
  meta: z.any().optional(),
});

export type TransactionFormDataWithValidation = z.infer<typeof transactionFormSchema>;
